import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { displayErrorToast, displaySuccessToast, isEmpty, numberToWords, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import {
    provisionalPayslipRequest, provisionalPayslipRequestStatus, newPayslipRequest,
    newPayslipRequestStatus
} from '../../../redux/payroll/payroll.action'
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select'
import PercentInputHalf from "../../../components/input/percent-input-half/percentInputHalf";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import { API_CONSTANTS } from "../../../utils/AppConstants";

const NewPayslip = props => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    const { newPayslipSuccess, newPayslipError, newPayslipReqStatus,
        provisionalPayslipSuccess, provisionalPayslipError, provisionalPayslipReqStatus
    } = useSelector(state => state.payroll)
    const { state } = useLocation()
    let navigate = useNavigate();
    const [year, setYear] = useState(new Date().getFullYear())
    const [month, setMonth] = useState(new Date().toLocaleString("default", { month: "long" }))
    const [workingDays, setWorkingDays] = useState('')
    const [allowanceType, setAllowanceType] = useState('')
    const [allowanceValueType, setAllowanceValueType] = useState()
    const [allowanceValue, setAllowanceValue] = useState('')
    const [isAllowanceTaxable, setIsAllowanceTaxable] = useState(false)
    const [allowanceList, setAllowanceList] = useState([])
    const [showAddAllowanceModal, setShowAAddAllowanceModal] = useState(false)
    const ALLOWANCE_VALUE_TYPE_LIST = [
        { key: 'FIXED', value: removeSpecialCharAndChangeToPascal('FIXED') },
        { key: 'PERCENTAGE', value: removeSpecialCharAndChangeToPascal('PERCENTAGE') }
    ]
    const formatDate = (date) => {
        const day = date.getDate(); // Get numeric day
        const month = date.toLocaleString("en-GB", { month: "long" }); // British English format
        return `${day} ${month}`; // Example: "1 March"
    };

    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const formattedRange = `${formatDate(firstDay)} – ${formatDate(today)} ${today.getFullYear()}`;

    const customSelectStyles = {
        menu: (provided) => ({
            ...provided,
            backgroundColor: "#fff", // Ensures dropdown background is white
            zIndex: 5
        }),
        option: (provided, state) => ({
            ...provided,
            cursor: "pointer"
        }),
    };

    useEffect(() => {
        if (provisionalPayslipReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
        } else if (provisionalPayslipReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(provisionalPayslipError.message)
        }
        if (provisionalPayslipReqStatus?.length) {
            dispatch(provisionalPayslipRequestStatus(''))
        }
    }, [provisionalPayslipSuccess, provisionalPayslipError, provisionalPayslipReqStatus])

    useEffect(() => {
        if (newPayslipReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(newPayslipSuccess.data?.message)
            setTimeout(() => {
                navigate(-1)
            }, 700)
        } else if (newPayslipReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(newPayslipError.message)
        }
        if (newPayslipReqStatus?.length) {
            dispatch(newPayslipRequestStatus(''))
        }
    }, [newPayslipSuccess, newPayslipError, newPayslipReqStatus])

    const handleProvisionalPayslipClick = () => {
        if (isEmpty(workingDays)) {
            displayErrorToast('Number of working days in selected month cannot be blank')
        } else {
            setLoading(true)
            const data = {
                employeeId: state.employeeId,
                businessId: state.businessId,
                locationId: state.locationId,
                workingDays: workingDays,
                allowances: allowanceList
            }
            dispatch(provisionalPayslipRequest(data))
        }
    }

    const handleConfirmClick = () => {
        if (isEmpty(workingDays)) {
            displayErrorToast('Number of working days in selected month cannot be blank')
        } else if (isEmpty(provisionalPayslipSuccess)) {
            displayErrorToast('Please generate provisional payslip data befor continuing')
        } else {
            setLoading(true)
            const data = {
                employeeId: state.employeeId,
                businessId: state.businessId,
                locationId: state.locationId,
                workingDays: workingDays,
                allowances: allowanceList
            }
            dispatch(newPayslipRequest(data))
        }
    }

    const handleAddAllowanceSubmitClick = () => {
        if (isEmpty(allowanceType)) {
            displayErrorToast('Allowance name cannot be blank')
        } else if (isEmpty(allowanceValueType)) {
            displayErrorToast('Value type not selected')
        } else if (isEmpty(allowanceValue)) {
            displayErrorToast('Allowance value cannot be blank')
        } else {
            setAllowanceList(prevList => [
                ...prevList,
                {
                    name: allowanceType,
                    valueType: allowanceValueType.key,
                    value: parseFloat(allowanceValue),
                    isTaxable: isAllowanceTaxable
                }
            ])
            setAllowanceType('')
            setAllowanceValue('')
            setAllowanceValueType(undefined)
            setIsAllowanceTaxable(false)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Payslip' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to generate payslip' />
                    <div className="pd-icon-row-container">
                        <div className="pd-icon-container">
                            <img src={require('../../../assets/ic_user.png')} className="img" />
                        </div>
                        <div className="pd-icon-label">{state.firstName} {state.lastName}</div>
                    </div>
                    <div className="pd-icon-row-container mb-3">
                        <div className="pd-icon-container">
                            <img src={require('../../../assets/ic_calendar.png')} className="img" />
                        </div>
                        <div className="pd-icon-label">{formattedRange}</div>
                    </div>

                    <CommonInputFloatFull
                        type='number'
                        id='workingDays'
                        onChange={e => setWorkingDays(e.target.value)}
                        placeholder='Working days'
                        value={workingDays}
                        subText='No. of working days in selected month'
                        isSubtext={true}
                    />
                    <FormFieldLabel label='Allowances' />
                    {!isEmpty(allowanceList) && <div className="nps-al-row-container">
                        {allowanceList.map(item => (<div className="nps-al-row-item">
                            <h5 className="nps-al-name">{item.name}</h5>
                            <p className="nps-al-value">{item.value}</p>
                            <div className="nps-al-tax">Taxable: {item.isTaxable ? 'Yes' : 'No'}</div>
                        </div>))}
                    </div>}
                    {isEmpty(allowanceList) && <div className="content-error">No allowances added</div>}
                    {!isEmpty(provisionalPayslipSuccess) && !isEmpty(provisionalPayslipSuccess.data) && <div className="nps-pp-container">
                        <div className="nps-pp-label">Provisional Payslip Calculations</div>
                        <div className="nps-pp-month-label">{provisionalPayslipSuccess.data.month}, {provisionalPayslipSuccess.data.year}</div>
                        <div className="row">
                            <div className="col-sm-6 nps-pp-container">
                                <div className="nps-pp-type-label">Salary Details</div>
                                <div className="nps-pp-salary-item-row-container">
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">Basic</div>
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{provisionalPayslipSuccess.data.baseSalary}</div>
                                </div>
                                <div className="nps-pp-salary-item-row-container">
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">Duration Type</div>
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{removeSpecialCharAndChangeToPascal(provisionalPayslipSuccess.data.salaryType)}</div>
                                </div>
                                <div className="nps-pp-salary-item-row-container">
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">Working Days</div>
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{provisionalPayslipSuccess.data.meta.presentDays}/{provisionalPayslipSuccess.data.meta.workingDays}</div>
                                </div>
                                <FormFieldLabel label='Allowances' />
                                {provisionalPayslipSuccess.data.allowances.map(item => (<div>
                                    <div className="nps-pp-salary-item-row-container">
                                        <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.name}</div>
                                        <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.amount} {item.taxable ? 'Taxable' : ''}</div>
                                    </div>
                                </div>))}
                            </div>
                            <div className="col-sm-5 nps-pp-container">
                                <div className="nps-pp-type-label">Deductions</div>
                                {provisionalPayslipSuccess.data.deductions.map(item => (<div>
                                    <div className="nps-pp-salary-item-row-container">
                                        <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.name}</div>
                                        <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.amount}</div>
                                    </div>
                                </div>))}
                                <FormFieldLabel label='Tax Details' />
                                <div className="nps-pp-salary-item-row-container">
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">Taxable Income</div>
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{provisionalPayslipSuccess.data.taxDetails.taxableIncome}</div>
                                </div>
                                <div className="nps-pp-salary-item-row-container">
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">Total Tax</div>
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{provisionalPayslipSuccess.data.taxDetails.totalTax}</div>
                                </div>
                            </div>
                        </div>
                        <div className="nps-pp-net-salary">Net Salary: {provisionalPayslipSuccess.data.netSalary} ({numberToWords(provisionalPayslipSuccess.data.netSalary)})</div>
                        <div className="nps-pp-payment">Payment Status: {provisionalPayslipSuccess.data.paymentStatus}</div>
                        <div className="nps-pp-btn" onClick={() => { handleConfirmClick() }}>Confirm &amp; Submit</div>
                    </div>}
                    <ButtonRow isVertical={true}>
                        <CommonButton isBig={true} isInverted={true} label='Add Allowances' onClick={() => { setShowAAddAllowanceModal(true) }} />
                        <CommonButton isBig={true} label='Provisional Payslip' onClick={() => { handleProvisionalPayslipClick() }} />
                        <div className="nps-disclaimer">✻✻ This will generate payroll based on employee's attendance for mentioned date range ✻✻</div>
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => {
                    setShowAAddAllowanceModal(false)
                }}
                show={showAddAllowanceModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Allowance
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Edit details to add new allowance' />
                    <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setAllowanceType(e.target.value)}
                        placeholder='Allowance Type'
                        value={allowanceType}
                    />
                    <FormFieldLabel label='Select Value Type' />
                    {ALLOWANCE_VALUE_TYPE_LIST && <Select
                        styles={customSelectStyles}
                        className='select-full-width-no-border'
                        value={allowanceValueType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={ALLOWANCE_VALUE_TYPE_LIST}
                        placeholder='Select Value Type'
                        onChange={e => setAllowanceValueType(e)} />}
                    {!isEmpty(allowanceValueType) && allowanceValueType.key === 'FIXED' && <CommonInputFloatFull
                        type='number'
                        id='valueFixed'
                        onChange={e => setAllowanceValue(e.target.value)}
                        placeholder='Value'
                        value={allowanceValue}
                    />}
                    {!isEmpty(allowanceValueType) && allowanceValueType.key !== 'FIXED' && <PercentInputHalf
                        type='number'
                        id='valuePercent'
                        onChange={e => setAllowanceValue(e.target.value)}
                        placeholder='Value'
                        value={allowanceValue}
                        isFullWidth={true}
                        subText='Percentage of salary'
                        isSubtext={true}
                    />}
                    {!isEmpty(allowanceValueType) && <CommonCheckbox
                        id='isTaxable'
                        label='Is Taxable'
                        value={isAllowanceTaxable}
                        onChange={() => {
                            setIsAllowanceTaxable(!isAllowanceTaxable)
                        }}
                    />}
                    <ButtonRow>
                        <CommonButton label='Add' onClick={() => { handleAddAllowanceSubmitClick() }} />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default NewPayslip